import React, { useState, Fragment } from 'react';
import { Textarea, TextInputField } from 'evergreen-ui';
import PropTypes from 'prop-types';
import BlockContainer from './BlockContainer';
import AttributeAPIContainer from '../elements/AttributeAPIContainer';
import { updateOnSelectAttribute, updateOnChangeText } from './../../utils';
import liveChatIcon from './../../pages/builder/assets/images/icons/livechat.svg';
import ButtonFragment from '../elements/ButtonFragment';
import TextCharInfo from '../elements/TextCharInfo';

const LiveChatBlock = ({
  id,
  text,
  setText,
  timeout,
  handleTimeout,
  save,
  button,
  saveBlock,
  saveLoader,
  updateButtonsBlock,
  attributeList,
  apiList,
  deleteBlock,
  sequences,
  copyBlock,
  moveBlock,
  hasWriteAccess,
}) => {
  const [showAttribute, setShowAttribute] = useState(false);
  const [showAPI, setShowAPI] = useState(false);
  const [maxCount] = useState(320);

  return (
    <BlockContainer
      id={id}
      title='Live Chat'
      subtitle='Live Chat is Where Your Bot Stops for Certain Delay'
      save={save}
      isLoading={saveLoader}
      icon={liveChatIcon}
      handleSaveClick={() => saveBlock(id)}
      handleDelete={() => deleteBlock(id)}
      sequences={sequences}
      handleCopy={copyBlock}
      handleMove={moveBlock}
      hasWriteAccess={hasWriteAccess}
    >
      <Fragment>
        <AttributeAPIContainer
          attributeList={attributeList}
          showAttribute={showAttribute}
          setShowAttribute={setShowAttribute}
          apiList={apiList.filter((api) => api.return_type === 'text')}
          showAPI={showAPI}
          setShowAPI={setShowAPI}
          handleSelect={(value) => {
            (text + value).length + 2 <= maxCount &&
              updateOnSelectAttribute(
                value,
                showAttribute,
                showAPI,
                setShowAttribute,
                setShowAPI,
                setText,
                text,
                apiList
              );
          }}
        >
          <Textarea
            required={true}
            grammarly={true}
            spellCheck={true}
            disabled={!hasWriteAccess}
            value={text}
            onChange={(e) =>
              e.target.value.length <= maxCount &&
              updateOnChangeText(
                e.target.value,
                setShowAttribute,
                setShowAPI,
                setText
              )
            }
            placeholder='Your text block content'
          />
        </AttributeAPIContainer>
        <TextCharInfo data={text} count={maxCount} />
        <ButtonFragment
          key={1}
          id={button.id}
          hasMessengerExtension={false}
          index={1}
          sequences={sequences}
          blockId={id}
          title={button.title}
          type={button.type}
          value={button.value}
          singleElem={true}
          handleUpdate={(data, type) => updateButtonsBlock(id, data, type)}
          allowedTypes={['Sequence']}
          hasWriteAccess={hasWriteAccess}
        />
        <br />
        <TextInputField
          label='Set Timeout (In Hours)'
          type='number'
          disabled={!hasWriteAccess}
          required
          value={timeout}
          onChange={(e) => handleTimeout(e.target.value)}
        />
      </Fragment>
    </BlockContainer>
  );
};

LiveChatBlock.propTypes = {
  id: PropTypes.number.isRequired,
  save: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  timeout: PropTypes.number.isRequired,
  handleTimeout: PropTypes.func.isRequired,
  button: PropTypes.object,
  setText: PropTypes.func.isRequired,
  saveBlock: PropTypes.func.isRequired,
  attributeList: PropTypes.arrayOf(PropTypes.string),
  apiList: PropTypes.arrayOf(PropTypes.object),
  deleteBlock: PropTypes.func.isRequired,
  moveBlock: PropTypes.func.isRequired,
  copyBlock: PropTypes.func.isRequired,
  saveLoader: PropTypes.bool.isRequired,
  hasWriteAccess: PropTypes.bool,
};

LiveChatBlock.defaultState = {
  deleteBlock: (blockId, SequenceId) =>
    console.log('delete from default props', blockId, SequenceId),
  hasWriteAccess: false,
};

export default LiveChatBlock;
